export interface IPaymentStatus {
  wasCancelled: boolean;
  wasSuccessful: boolean;
}
